import { render, staticRenderFns } from "./json-header.vue?vue&type=template&id=2eb42a06&scoped=true"
import script from "./json-header.vue?vue&type=script&lang=js"
export * from "./json-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb42a06",
  null
  
)

export default component.exports